<template>
  <div class="form-producto-final-bulk container mt-4 p-4 rounded shadow-sm">

    <!-- Título -->
    <h3 class="mb-4 text-bulk-dark">
      <font-awesome-icon :icon="['fas', 'box-open']" class="me-2" />
      Crear Producto Final Bulk
    </h3>

    <form @submit.prevent="submitForm">

      <!-- Materia prima -->
      <div class="seccion mb-4">
        <h6 class="seccion-titulo">Materia Prima</h6>

      
        
        <select v-model.number="form.materia_prima_id" class="form-select" required @change="onMateriaPrimaChange"
          :disabled="materia_prima">
          <option value="" disabled>Seleccione materia prima…</option>
          <option v-for="m in materiaFiltrada" :key="m.id" :value="m.id">
            {{ m.codigo }} - {{ m.tipo || 'Sin tipo' }} ({{ m.cantidad }} {{ m.unidad_medida }})
          </option>
        </select>
      </div>


      <!-- Código Lote -->
      <div class="seccion mb-4">
        <h6 class="seccion-titulo">Identificación</h6>
        <div class="input-group">
          <input v-model="form.codigo" type="text" class="form-control" disabled />
          <button type="button" class="btn btn-outline-bulk" @click="generarCodigo">Generar</button>
        </div>
      </div>

      <!-- Cantidad, Unidad, Tipo Producto -->
      <div class="seccion mb-4">
        <h6 class="seccion-titulo">Detalles del Producto</h6>
        <div class="row g-3">

          <div class="col-md-4">
            <label>Cantidad Final</label>
            <div class="input-group">
              <input v-model.number="form.cantidad" type="number" class="form-control"
                :max="materiaPrimaSeleccionada?.cantidad" min="0.1" step="0.1" required />
              <button type="button" class="btn btn-outline-bulk" @click="usarMaximo">MAX</button>
            </div>
            <small class="text-muted">Disponible: {{ cantidadDisponible }} {{ form.unidad_medida }}</small>
          </div>

          <div class="col-md-3">
            <label>Unidad de Medida</label>
            <input v-model="form.unidad_medida" type="text" class="form-control" disabled />
          </div>

          <div class="col-md-5">
            <label>Tipo de Producto</label>
            <select v-model.number="form.tipo_producto" class="form-select"
              :disabled="form.tipo_es_igual_a_materia_prima" required>
              <option value="" disabled>Seleccione tipo...</option>
              <option v-for="tipo in tiposProductos" :key="tipo.id" :value="tipo.id">{{ tipo.descripcion }}</option>
            </select>

            <div class="form-check mt-2">
              <input v-model="form.tipo_es_igual_a_materia_prima" type="checkbox" class="form-check-input"
                id="checkIgualMateriaPrima">
              <label class="form-check-label" for="checkIgualMateriaPrima">Es igual a la Materia Prima (No
                derivado)</label>
            </div>
          </div>

        </div>
      </div>

      <!-- Fechas -->
      <div class="seccion mb-4 bg-light border rounded p-3">
        <h6 class="seccion-titulo mb-3">Fechas de Producción y Vencimiento</h6>
        <div class="row g-3 align-items-end">

          <div class="col-md-4">
            <label>Fecha de Producción</label>
            <input v-model="form.fecha_produccion" type="date" class="form-control" required />
          </div>

          <div class="col-md-4">
            <label>Días hasta vencimiento</label>
            <input v-model.number="form.dias_vencimiento" @input="calcularFechaVencimiento" type="number" min="0"
              class="form-control" placeholder="Ej: 180" />
          </div>

          <div class="col-md-4">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.fecha_vencimiento" @input="calcularDiasVencimiento" type="date" class="form-control" />
          </div>

        </div>
      </div>

      <!-- Observaciones -->
      <div class="seccion mb-4">
        <h6 class="seccion-titulo">Observaciones</h6>
        <textarea v-model="form.observaciones" class="form-control" rows="3" placeholder="Opcional..."></textarea>
      </div>

      <!-- Botones -->
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" @click="$emit('cancelar')" class="btn btn-outline-secondary">Cancelar</button>
        <button type="submit" class="btn btn-bulk">Crear Producto Final Bulk</button>
      </div>

    </form>
  </div>
</template>

<script>
import axios from '@/axios';
import { format, addDays, differenceInDays } from 'date-fns';

export default {
  name: 'FormProductoFinalBulkCrear',
  props: {
    materia_prima: {
      type: Object,
      default: null
    }
  },
  data() {
    const hoy = new Date();
    return {
      form: {
        codigo: '',
        materia_prima_id: null,
        cantidad: null,
        unidad_medida: '',
        tipo_producto: '',
        tipo_es_igual_a_materia_prima: false,
        fecha_produccion: format(hoy, 'yyyy-MM-dd'),
        fecha_vencimiento: '',
        dias_vencimiento: null,
        observaciones: '',
        club_id: this.$store.getters.getClubActual.id,
        proyecto_id: null
      },
      club_id: this.$store.getters.getClubActual.id,
      listaMateriaPrima: [],
      tiposProductos: [],
      cantidadDisponible: 0,
      filtroMateria: ''
    };
  },

  watch: {
    'form.tipo_es_igual_a_materia_prima'(val) {
      if (val && this.materiaPrimaSeleccionada) {

        this.tiposProductos.push({
          id: this.materiaPrimaSeleccionada.tipo,
          descripcion: this.materiaPrimaSeleccionada.tipo
        });
        this.form.tipo_producto = this.materiaPrimaSeleccionada.tipo;
      } else {
        this.form.tipo_producto = null;
        this.fetchTiposProductos();
      }
    },

    'form.cantidad'(newVal) {
      if (!newVal) return;

      const redondeado = Math.round(newVal * 10) / 10;

      if (this.materiaPrimaSeleccionada) {
        const max = this.materiaPrimaSeleccionada.cantidad;

        if (redondeado > max) {
          this.form.cantidad = Math.floor(max * 10) / 10;
        } else if (redondeado < 0.1) {
          this.form.cantidad = 0.1;
        } else {
          this.form.cantidad = redondeado;
        }
      }
    }
  },

  computed: {
    materiaPrimaSeleccionada() {
      return this.listaMateriaPrima.find(m => m.id === this.form.materia_prima_id);
    },
    materiaFiltrada() {
      const filtro = this.filtroMateria.trim().toLowerCase();
      if (!filtro) return this.listaMateriaPrima;
      return this.listaMateriaPrima.filter(m =>
        m.codigo?.toLowerCase().includes(filtro)
      );
    },

  },

  async created() {
    this.form.materia_prima_id = this.materia_prima?.id || null;
    this.form.cantidad = this.materia_prima?.cantidad || null;
    this.form.unidad_medida = this.materia_prima?.unidad_medida || null;
    await this.generarCodigo();
    await this.fetchMateriaPrima();
    await this.fetchTiposProductos();
  },

  methods: {
    async generarCodigo() {
      if (!this.form.materia_prima_id) return;

      const res = await axios.get('/api/producto_final_bulk_generarCodigoLote', {
        params: { club_id: this.club_id, materia_prima_id: this.form.materia_prima_id }
      });

      this.form.codigo = res.data.codigo;
    },

    async fetchMateriaPrima() {
      const res = await axios.get('/api/materia_prima_stock', {
        params: { club_id: this.club_id }
      });
      this.listaMateriaPrima = res.data || [];
    },

    async fetchTiposProductos() {
      const res = await axios.get('/api/constantes/tipos_de_productos_derivados_de_cannabis');
      this.tiposProductos = res.data || [];
    },

    onMateriaPrimaChange() {
      const materiaSeleccionada = this.listaMateriaPrima.find(m => m.id === this.form.materia_prima_id);
      if (materiaSeleccionada) {
        this.form.unidad_medida = materiaSeleccionada.unidad_medida;
        this.cantidadDisponible = materiaSeleccionada.cantidad;
        this.form.cantidad = null;

        // Si el check está tildado, setear el tipo_producto
        if (this.form.tipo_es_igual_a_materia_prima) {
          this.form.tipo_producto = materiaSeleccionada.tipo || '';
        }
      }

      this.generarCodigo();
    },

    usarMaximo() {
      this.cantidadDisponible = this.materiaPrimaSeleccionada.cantidad;
      this.form.cantidad = this.cantidadDisponible;
    },

    calcularFechaVencimiento() {
      if (this.form.dias_vencimiento && this.form.fecha_produccion) {
        const fecha = addDays(new Date(this.form.fecha_produccion), this.form.dias_vencimiento);
        this.form.fecha_vencimiento = format(fecha, 'yyyy-MM-dd');
      }
    },

    calcularDiasVencimiento() {
      if (this.form.fecha_vencimiento && this.form.fecha_produccion) {
        const dias = differenceInDays(new Date(this.form.fecha_vencimiento), new Date(this.form.fecha_produccion));
        this.form.dias_vencimiento = dias >= 0 ? dias : null;
      }
    },

    async submitForm() {
      const materiaSeleccionada = this.listaMateriaPrima.find(m => m.id === this.form.materia_prima_id);
      if (!materiaSeleccionada) {
        alert("Debe seleccionar una materia prima válida");
        return;
      }

      this.cantidadDisponible = materiaSeleccionada.cantidad;
      if (this.form.cantidad > this.cantidadDisponible) {
        alert(`La cantidad usada no puede superar la cantidad disponible (${this.cantidadDisponible})`);
        return;
      }

      const payload = {
        ...this.form,
        club_id: this.club_id,
        proyecto_id: materiaSeleccionada.proyecto_id
      };

      await axios.post('/api/producto_final_bulk', payload);
      alert('Producto Final Bulk creado correctamente');
      this.$emit('productoFinalBulkCreado');
    }
  }
};
</script>





<style scoped>
.form-producto-final-bulk {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.05);
}

h3 {
  font-weight: 600;
  color: #18415d;
}

.seccion {
  margin-bottom: 1.5rem;
}

.seccion-titulo {
  font-size: 0.9rem;
  font-weight: 600;
  color: #18415d;
  margin-bottom: 0.75rem;
}

input,
select,
textarea {
  font-size: 0.95rem;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.bg-light {
  background-color: #f8fafc !important;
}

.btn-bulk {
  background-color: #18415d;
  color: white;
}

.btn-bulk:hover {
  background-color: #123349;
}

.btn-outline-bulk {
  border-color: #18415d;
  color: #18415d;
}

.btn-outline-bulk:hover {
  background-color: #18415d;
  color: white;
}
</style>